import { NoteType } from "@/api/dtos";

const mapping: Record<NoteType, string> = {
    [NoteType.Annotation]: 'Annotation',
    [NoteType.InternalQuery]: 'Internal',
    [NoteType.ProtocolDeviation]: 'Protocol Deviation',
    [NoteType.ImportantProtocolDeviation]: 'Important Protocol Deviation',
    [NoteType.ReasonForChange]: 'Reason For Change',
    [NoteType.SiteQuery]: 'Query',
    [NoteType.System]: 'Failed Validation Check',
};

const noteTypeToText = (type?: NoteType) => {
    if (!type) {
        return 'Unknown'
    }

    return mapping[type];
}

export default noteTypeToText;